import { Box, HStack, Link, Stack, Text, VStack } from '@chakra-ui/react';
import { IoLink } from 'react-icons/io5';
import { IResourceExemptions } from '../../../../../services/hooks/Resources/useGetRequestNewResource';

interface IOwnProps {
  selectedExemption?: string;
  exemption?: IResourceExemptions;
}

const InformationExemptionCreateResource: React.FC<IOwnProps> = ({ exemption, selectedExemption }) => {
  if (!selectedExemption || !exemption) return;

  return (
    <Box _dark={{ bg: 'gray.700' }} p={0} rounded="xl" shadow="sm">
      <Text fontWeight="semibold" mb={2} borderBottom="1px solid" borderColor="gray.400" pb={1} w="fit-content" pr={4}>
        {exemption?.type}
      </Text>
      {!exemption.justification && (
        <>
          <Text fontWeight="semibold" mb={0}>
            <b>Resposta à solicitação de isenção:</b>
          </Text>
          <Box
            fontSize="sm"
            color="gray.600"
            dangerouslySetInnerHTML={{ __html: exemption?.justification || 'Sem justificativa...' }}
          />
        </>
      )}

      {exemption?.attachements?.length > 0 && (
        <VStack align="stretch" mt={exemption.justification ? 4 : 2} spacing={0} pb={1}>
          <Text fontWeight="semibold">Anexos enviados</Text>
          {exemption.attachements.map((attach) => (
            <Stack gap={0}>
              <HStack
                key={attach.id}
                spacing={2}
                p={1}
                px={2}
                color="blue.500"
                rounded="md"
                _hover={{ bg: 'gray.100' }}
              >
                <Box>
                  <IoLink />
                </Box>
                <Link fontSize="0.75rem" href={attach.url} target="_blank">
                  {attach.name}
                </Link>
              </HStack>
              <Box ml={8} mt={-1}>
                <Text fontSize="0.65rem" whiteSpace="nowrap" color="gray.500">
                  {attach.created_at}
                </Text>
              </Box>
            </Stack>
          ))}
        </VStack>
      )}
    </Box>
  );
};

export default InformationExemptionCreateResource;
